<template>
  <div class="d-flex">
    <gpt-suggestion-modal
      v-if="
        this.gptData?.suggestionSource ===
        this.GPT_SUGGESTION_SOURCE.GPT_AUTO_COMPLETION
      "
      @select="pasteSuggestionIntoMessageInput"
      @send="onSuggestionSent"
      :suggestions="suggestions"
    />
    <get-gpt-suggestion-button :last-message="lastMessage" :loading="loading" />
    <v-btn
      @click="declineGptSuggestion"
      :disabled="loading || gptResponseLoading"
      :loading="loading"
      color="red"
      class="white--text mr-2"
      depressed
      fab
      small
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import GetGptSuggestionButton from './GetGptSuggestionButton.vue';
import GptSuggestionModal from './GptSuggestionModal.vue';
import { SUPPORT_DECISION, GPT_SUGGESTION_SOURCE } from '@/lib/const';

export default {
  name: 'GptPanel',
  components: {
    GetGptSuggestionButton,
    GptSuggestionModal,
  },

  props: {
    lastMessage: {
      type: Object,
      required: false,
    },
    loading: Boolean,
  },

  data() {
    return { GPT_SUGGESTION_SOURCE };
  },

  computed: {
    currentChatId() {
      return this.$store.state.chat.currentChatId;
    },

    gptResponseLoading() {
      return this.$store.state.gpt.loading;
    },

    lastMessageId() {
      return this.lastMessage?.messageId;
    },

    gptData() {
      return this.$store.state.gpt.data;
    },

    suggestions() {
      if (!this.gptData) {
        return [];
      }

      return this.gptData.suggestions || [];
    },
  },

  methods: {
    declineGptSuggestion() {
      this.$store.commit('gpt/UPDATE_DATA', {
        key: 'supportDecision',
        value: SUPPORT_DECISION.NO,
      });
      this.$store.commit('chat/SET_MESSAGE_INPUT', '', { root: true });
    },

    pasteSuggestionIntoMessageInput(index) {
      this.$store.commit('gpt/UPDATE_DATA', {
        key: 'supportDecision',
        value: SUPPORT_DECISION.YES,
      });
      const suggestion = this.gptData.suggestions?.[index];
      const messageForInput = suggestion?.message || '';
      this.$store.commit('chat/SET_MESSAGE_INPUT', messageForInput, {
        root: true,
      });
    },

    onSuggestionSent() {
      // gpt mode and data already cleared by the modal
    },
  },
};
</script>
